import React from "react";
import { useParams } from "react-router-dom";
import articlesData from "../data/articles.json";
import BestsellersArticle from "../componentes/articles/BestSellersArticle.js";
import HemingwayArticle from "../componentes/articles/HemingwayArticle.js";
import ZafonArticle from "../componentes/articles/ZafonArticle.js";
import LiteratureArticle from "../componentes/articles/LiteratureArticle.js";
import CommunityArticle from "../componentes/articles/CommunityArticle.js";
import AuthorsArticle from "../componentes/articles/AuthorsArticle.js";

const Article = () => {
  const { id } = useParams();
  const article = articlesData.find((a) => a.id === id);

  const articleComponents = {
    bestsellers: BestsellersArticle,
    hemingway: HemingwayArticle,
    zafon: ZafonArticle,
    literature: LiteratureArticle,
    community: CommunityArticle,
    authors: AuthorsArticle,
  };

  const ArticleComponent = articleComponents[id];

  if (!article) {
    return (
      <section aria-labelledby="not-found-title">
        <h1>OOPS!</h1>
        <p>Article not found or it has been moved</p>
      </section>
    );
  }

  return <ArticleComponent />;
};

export default Article;
